module.exports = __webpack_public_path__ + "img/print-icon.b6d04beb.svg";